import PlayerComplaintActionType from 'actions/playerComplaint/playerComplaintActionType';

const initialState = {
  playerComplaints: {},
};

const playerComplaintReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case PlayerComplaintActionType.SAVE_PLAYER_COMPLAINTS:
    return {
      ...state,
      playerComplaints: payload.data,
    };
  case PlayerComplaintActionType.RESET_PLAYER_COMPLAINTS:
    return {
      ...state,
      playerComplaints: {},
    };
  default:
    return state;
  }
};

export default playerComplaintReducer;
